export default {

    state: {
        pageLoading: false
    },

    getters: {
        pageLoading: state => state.pageLoading
    },

    mutations: {
        SET_PAGE_LOADING(state, loading) {
            state.pageLoading = loading
        }
    },

    actions: {
        PAGE_LOADING_SET(context) {
            context.commit('SET_PAGE_LOADING', true)
        },
        PAGE_LOADING_RESET(context) {
            context.commit('SET_PAGE_LOADING', false)
        }
    }

}